/**
 *
 * Asynchronously loads the component for Dashboard
 *
 */

import loadable from "util/loadable";

export default loadable(() => import("./index"));
